import { ReducerRegistry } from 'store';
import {
  ADD_TEAM_MEMBER_ASYNC,
  ADD_TEAM_MEMBER_COMPLETE,
  EDIT_TEAM_MEMBER_ASYNC,
  EDIT_TEAM_MEMBER_COMPLETE,
  DELETE_TEAM_MEMBER_ASYNC,
  DELETE_TEAM_MEMBER_COMPLETE,
  SUSPEND_TEAM_MEMBER_ASYNC,
  SUSPEND_TEAM_MEMBER,
  ACTIVATE_TEAM_MEMBER_ASYNC,
  ACTIVATE_TEAM_MEMBER,
  FETCH_TEAM_ASYNC,
  FETCH_TEAM_COMPLETE,
  SELECT_TEAM_MEMBER,
  FETCH_TEAM_ASYNC_END,
} from '../types';

const INIT_STATE = {
  isFetchingTeam: false,
  inProgress: false,
  error: null,
  members: [],
  pagination: {
    limit: 5,
    page: 1,
  },
  selectedMember: null,
};

export const teamReducer = ReducerRegistry.register(
  'team',
  (state = INIT_STATE, { type, payload }) => {
    switch (type) {
      case FETCH_TEAM_ASYNC:
        return {
          ...state,
          isFetchingTeam: true,
          members: [],
        };
      case FETCH_TEAM_ASYNC_END:
        return {
          ...state,
          isFetchingTeam: false,
        };
      case FETCH_TEAM_COMPLETE:
        return {
          ...state,
          isFetchingTeam: false,
          members: payload.list,
          pagination: payload.pagination,
        };
      case ADD_TEAM_MEMBER_ASYNC:
        return {
          ...state,
          inProgress: true,
        };
      case ADD_TEAM_MEMBER_COMPLETE:
        return {
          ...state,
          inProgress: false,
        };
      case EDIT_TEAM_MEMBER_ASYNC:
        return {
          ...state,
          inProgress: true,
        };
      case EDIT_TEAM_MEMBER_COMPLETE:
        return {
          ...state,
          inProgress: false,
        };
      case DELETE_TEAM_MEMBER_ASYNC:
        return {
          ...state,
          inProgress: true,
        };
      case DELETE_TEAM_MEMBER_COMPLETE:
        return {
          ...state,
          inProgress: false,
        };
      case SUSPEND_TEAM_MEMBER_ASYNC:
        return {
          ...state,
          inProgress: true,
        };
      case SUSPEND_TEAM_MEMBER:
        return {
          ...state,
          inProgress: false,
        };

      case ACTIVATE_TEAM_MEMBER_ASYNC:
        return {
          ...state,
          inProgress: true,
        };
      case ACTIVATE_TEAM_MEMBER:
        return {
          ...state,
          inProgress: false,
        };
      case SELECT_TEAM_MEMBER:
        return {
          ...state,
          selectedMember: payload,
        };
      default:
        return state;
    }
  }
);
